<template>
  <main
    v-if="content"
    class="single">
    <div class="single__info">
      <h3 v-html="getFurnitureName(content)"></h3>
      <div
        class="single__info-details"
        v-html="content.details"></div>
    </div>
    <slideshow
      class="single__slideshow"
      :items="content.slideshow"
      :include-highlight="true"></slideshow>
    <div class="single__name">
      <h2 v-html="content.name"></h2>
    </div>
    <div class="single__navigation">
      <ul>
        <li>
          <a
            :href="`mailto:projects@jonathanwest.com.au&subject=${content.name}`"
            target="_blank"
            rel="noopener noreferrer">Enquire</a>
        </li>
        <li>
          <router-link to="/furniture" v-html="`Back to all furniture`"></router-link>
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
import Slideshow from '@/components/Slideshow'
export default {
  name: 'FurnitureSingle',
  components: {
    Slideshow
  },
  data() {
    return {
      content: null
    }
  },
  async created() {
    this.content = await this.getContent()

    this.$Progress.finish()
  },
  methods: {
    getContent() {
      return new Promise((resolve, reject) => {
        this.$http.get(`${process.env.VUE_APP_API_ADDRESS}/furniture/${this.$route.params.slug}`)
          .then(response => response.json())
          .then(result => resolve(result))
      })
    },
    getFurnitureName(item) {
      return item.year !== '' ? `${item.name} (${item.year})` : item.name
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$Progress.start()
    })
  }
}
</script>

<style lang="scss" scoped>
.single {
  @include page($margin: false);
  font-family: $maison;
  margin-bottom: #{$site-padding};

  &__info {
    // width:%;
    min-height: 11.25rem;
    margin:0 calc(140px + #{$site-padding}) $site-padding-lrg 15%;
    max-width: 1400px;
    h3 {
      font-size:$body;
      text-transform:uppercase;
    }
  }

  &__name {
    margin: $site-padding-lrg 0;
    h2 {
      font-family: $maison;
      font-size: $heading;
      text-transform: uppercase;
      text-align:center;
    }
  }

  &__navigation {
    font-family: $ops-placard;

    a {
      display:inline-block;
      padding:$site-padding-lrg;
      width:100%;
      border: 2px solid #000;
      text-align:center;

      &:last-child {
        margin-top: -2px;
      }

      &:hover {
        background-color:#000;
        color:#fff;
      }
    }
  }

  @include mobile {
    &__info {
      width:100%;
      min-height:unset;
      margin:0 auto 0.625rem auto;
      h3 {
        font-size:$body--m;
      }
    }

    &__name {
      display:none;
    }

    &__navigation {
      margin: #{$site-padding-lrg * 2} 0 0 0;
      ul {
        li {
          text-align: center;
          // margin:#{$site-padding} 0;
          a {
            font-size: $body--m;
            padding: $site-padding--m;
          }
        }
      }
    }
  }
}
</style>
